export default __webpack_public_path__ + "static/media/2018-10-25-mar-in-scales.329ff8e8.csv";